
export default "/assets/book-open-micro.ebda3148.svg"